import script from "./lookup-multi-select.vue?vue&type=script&setup=true&lang=ts"
export * from "./lookup-multi-select.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__